import script from "./FormLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./FormLabel.vue?vue&type=script&setup=true&lang=js"

import "./FormLabel.vue?vue&type=style&index=0&id=03d8dab3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03d8dab3"]])

export default __exports__